export const COLORS_MAP = {
  blue: {
    value: 'blue',
    nameId: 'dbl_chart_map_color_blue',
    colors: ['#F0F7FF', '#CFE4FF', '#A6C9FF', '#7DADFF', '#5086F3']
  },
  yellow: {
    value: 'yellow',
    nameId: 'dbl_chart_map_color_yellow',
    colors: ['#FFFDE8', '#FFF9BF', '#FFF196', '#FFE76E', '#F5D242']
  },
  green: {
    value: 'green',
    nameId: 'dbl_chart_map_color_green',
    colors: ['#F0FFF5', '#E9F7EE', '#C0EBD2', '#92DEB4', '#69D19C']
  },
  red: {
    value: 'red',
    nameId: 'dbl_chart_map_color_red',
    colors: ['#FFF1F0', '#FFE6E6', '#FFD4D4', '#FFABAF', '#F17C86']
  },
  custom: {
    value: 'custom',
    nameId: 'dbl_chart_map_color_custom',
    colors: ['#F2F3F5', '#F2F3F5', '#F2F3F5', '#F2F3F5', '#F2F3F5']
  }
};

export const WORDCLOUD_COLORS_MAP = {
  blue: {
    value: 'blue',
    nameId: 'dbl_chart_map_color_blue',
    colors: ['#D7E3F9', '#B9CFFA', '#96B6F8', '#739EF5', '#5086F3']
  },
  yellow: {
    value: 'yellow',
    nameId: 'dbl_chart_map_color_yellow',
    colors: ['#F9EA8D', '#FFE76E', '#F5D242', '#CFA92D', '#A8831D']
  },
  green: {
    value: 'green',
    nameId: 'dbl_chart_map_color_green',
    colors: ['#C0EBD2', '#92DEB4', '#69D19C', '#4DAB7D', '#358561']
  },
  red: {
    value: 'red',
    nameId: 'dbl_chart_map_color_red',
    colors: ['#F4DEDE', '#FFCCCC', '#FFABAF', '#F17C86', '#CC5E6B']
  },
  custom: {
    value: 'custom',
    nameId: 'dbl_chart_map_color_custom',
    colors: ['#F2F3F5', '#F2F3F5', '#F2F3F5', '#F2F3F5', '#F2F3F5']
  }
};

export const MULITI_COLORS_MAP = {
  light: {
    value: 'light',
    nameId: 'dbl_chart_map_color_light',
    colors: ['#A6C9FF', '#C0EBD2', '#8CE2FF', '#FFF196', '#FFCCCC']
  },
  dark: {
    value: 'dark',
    nameId: 'dbl_chart_map_color_dark',
    colors: ['#3965CC', '#4DAB7D', '#45A1CC', '#CFA92D', '#CC5E6B']
  },
  custom: {
    value: 'custom',
    nameId: 'dbl_chart_map_color_custom',
    colors: ['#F2F3F5', '#F2F3F5', '#F2F3F5', '#F2F3F5', '#F2F3F5']
  }
};

export const CUSTOM_HEXS = [
  '#5086F3', '#69D19C', '#6E7794', '#F5D242', '#7F6FF1', '#5EC8F1',
  '#AD53D4', '#F19E55', '#488E89', '#F17C86', '#7DADFF', '#92DEB4', '#949BB3', '#FFF196'
];